module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-custom"
  }, [(_vm.clientBalance.balance) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Текущий баланс")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.clientBalance.balance), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', {
      staticClass: "td-resource"
    }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
      staticClass: "td-value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.clientBalance.creditLimit) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v(" Кредитный лимит ")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.clientBalance.creditLimit), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', {
      staticClass: "td-resource"
    }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
      staticClass: "td-value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.replenishmentResourcesPage && _vm.replenishmentResourcesPage.content) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Пополнения")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.replenishmentResourcesPage.content), function(addResource) {
    return _c('tr', {
      key: addResource.id
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v("\n          " + _vm._s(_vm.getDateFormat((addResource.timestampUtcMillis / 1000) < 1000000000000 ? addResource.timestampUtcMillis : addResource.timestamp / 1000)) + "\n        ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table is-bordered"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((addResource.resources), function(value, name) {
      return _c('tr', {
        key: name
      }, [(value) ? _c('td', {
        staticClass: "td-resource"
      }, [_vm._v(_vm._s(name) + "\n                ")]) : _vm._e(), _vm._v(" "), (value) ? _c('td', {
        staticClass: "td-value"
      }, [_vm._v(_vm._s(value) + "\n                ")]) : _vm._e()])
    }), 0)])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadReplenishmentResourcesPage,
      "per-page": _vm.replenishItemsPerPage,
      "data": _vm.replenishmentResourcesPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.replenishmentResourcesPage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Дата пополнения\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Пополняемые ресурсы\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058a52ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/billing/Balance.vue
// module id = 385
// module chunks = 42